var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"lineChart",staticClass:"linechart",staticStyle:{"width":"90%","height":"90%","justify-content":"center","align-items":"center","padding-bottom":"100px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }